import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import {
    action_fetch_tag_clogs,
    action_add_tag_clogs,
} from '../../../../store/actions/pages/c-log'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

import List from '../components/list'
import { useQuery } from '../../../hooks/common'

import { useRouteMatch } from 'react-router-dom'
import { matchRoutes } from 'react-router-config'
import routes from '../../../../routes/c-log'
// import BottomNavigation from '../../../layout/fragments/bottom-navigation'

const CLog = props => {
    useStyles(classes)
    const pageCLog = useSelector(state => state.pageCLog)
    const dispatch = useDispatch()
    const store = useStore()
    const query = useQuery()

    const match = useRouteMatch()

    useEffect(() =>{
        const branches = matchRoutes(routes, match.url)
        const routeExample = branches?.[0]?.route

        window.pageTitle = routeExample?.cn_page
        if (window.GeekoSensors) {
            window.GeekoSensors.Quick('autoTrackSinglePage', {page_title: routeExample?.cn_page})
        }
    },[])

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
            delete window.__INITIAL_STATE__
        } else {
            CLog.fetchData(store, {tag: query?.tag}, query, {})
            window.scrollTo({
                top: 0,
            })
        }
    }, [query?.tag])

    const onRequest = () => {
        const value = query?.tag
        dispatch(action_add_tag_clogs({ tag:value, skip: pageCLog?.tagSkip }, {}))
    }


    return <div> 
        <div className={classes.Title}>
            #{query?.tagname || query?.tag}
        </div>
        <div className={classes.List}>
            <List showings={pageCLog.tagClogs} request={onRequest} loading={pageCLog.tagLoading} finished={pageCLog.tagFinished} tab={query?.tag} />
        </div>
        {/* <BottomNavigation /> */}
    </div>
}

CLog.fetchData = async (store, params, search, headers) => {
    const tag = search?.tag
    await store.dispatch(action_fetch_tag_clogs({ tag }, headers))
}

export default CLog
